import { colorSystem } from '@luminovo/design-system';
import { formatDecimal } from '@luminovo/frontend-utils';

export const MONETARY_EPSILON = 0.005;

export const BASELINE_COLOR = colorSystem.green[4];
export const BASELINE_TEXT_COLOR = colorSystem.green[7];

/** A net change as a share of the baseline, signed with the same minus as the amounts. */
export function formatPct(net: number, baselineTotal: number): string | null {
    if (baselineTotal === 0) return null;
    const pct = (net / baselineTotal) * 100;
    const sign = pct > 0 ? '+' : pct < 0 ? '−' : '';
    return `${sign}${formatDecimal(Math.abs(pct), { maximumFractionDigits: 1 })}%`;
}
